import CurrencyAmount from '@components/currency-amount/CurrencyAmount';
import {
  formatTermDate,
  isPaidComplete,
  isTermDisabled,
  nonZeroAmount,
  paymentStatus
} from '@features/transactions/helpers/installmentSchedule';
import { PaymentOrderTermType } from '@types';

import SendTermPaymentLinkAction from './SendTermPaymentLinkAction';

const PaidPendingSplit = ({ row }: { row: PaymentOrderTermType }) => (
  <p className="flex flex-wrap items-center gap-x-2 text-xs">
    <span className="inline-flex items-center gap-0.5 font-medium text-cofeeGreen7">
      Paid:
      <CurrencyAmount
        value={Number(row.paid_amount ?? 0)}
        className="gap-0.25"
        symbolClass="!text-xs text-cofeeGreen7"
        valueClass="font-medium text-cofeeGreen7"
      />
    </span>
    <span className="text-cofeeNeutralInactive">|</span>
    <span className="inline-flex items-center gap-0.5 font-medium text-cofeeOrange6">
      Pending:
      <CurrencyAmount
        value={Number(row.pending_amount ?? 0)}
        className="gap-0.25"
        symbolClass="!text-xs text-cofeeOrange6"
        valueClass="font-medium text-cofeeOrange6"
      />
    </span>
  </p>
);

const InstallmentTermCardAmount = ({
  row,
  memberId
}: {
  row: PaymentOrderTermType;
  memberId: string;
}) => {
  if (isPaidComplete(row)) {
    return row.paid_on ? (
      <p className="mt-2 text-sm font-normal text-grey">
        Paid on {formatTermDate(row.paid_on)}
      </p>
    ) : null;
  }

  const status = paymentStatus(row);

  if (
    !row.due_date &&
    status !== 'processing' &&
    status !== 'payment_order_pending'
  ) {
    return null;
  }

  const showPaidPendingSplit =
    status === 'processing' &&
    nonZeroAmount(row.paid_amount) &&
    nonZeroAmount(row.pending_amount);

  return (
    <div className="space-y-1">
      {row.due_date && (
        <p
          className={
            isTermDisabled(row)
              ? 'text-sm font-normal text-grey line-through'
              : 'text-sm font-normal text-grey'
          }
        >
          Due on {formatTermDate(row.due_date)}
        </p>
      )}
      {showPaidPendingSplit && <PaidPendingSplit row={row} />}
      <SendTermPaymentLinkAction
        memberId={memberId}
        canSendPaymentLink={Boolean(row.can_send_payment_link)}
      />
    </div>
  );
};

export default InstallmentTermCardAmount;
